/** @jsx jsx */
import { jsx } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Styles
import * as style from './style';

const Divisor: FunctionComponent = React.memo(() => <hr sx={style.Divisor} />);

export default Divisor;
